module.exports = __webpack_public_path__ + "img/seckill-bg.dd0752e5.png";